

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BlackwakeCheckoutInfo extends Vue {
  name: 'BlackwakeCheckoutInfo';

  multiplier = 2.5;

  @Prop({ type: Number, default: 10 }) readonly slots: number;

  /**
         * calculcate the megabytes that the customer get (from legacy order.js)
         */
  fleetSlots(): number {
    return 54;
  }
}
